export type StudyNameTranslation = {
  lang: string;
  name: string | null;
};

export function normalizeUiLang(lang?: string | null): string {
  const t = (lang ?? "en").trim().split("-")[0].toLowerCase();
  return t || "en";
}

/** Participant/admin UI label; falls back to canonical English name. */
export function resolveStudyDisplayName(
  canonicalName: string,
  translations: StudyNameTranslation[] | undefined,
  lang?: string | null,
  localizedName?: string | null,
): string {
  if (localizedName != null && String(localizedName).trim() !== "") {
    return String(localizedName).trim();
  }
  const normalized = normalizeUiLang(lang);
  if (normalized === "en") return canonicalName;
  const row = translations?.find((t) => t.lang.toLowerCase() === normalized);
  if (row?.name != null && String(row.name).trim() !== "") {
    return String(row.name).trim();
  }
  return canonicalName;
}
